'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcValidate
* @element ANY
* @description
* # tcValidate
* Performs field validation
*/
angular.module('tc.validate', ['tc.global'])
.directive('tcValidate', function(GlobalService, $window) {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, element, attrs, ngModelCtrl) {
			var dataType = attrs.tcValidate;
			var allowExpressions = Object.prototype.hasOwnProperty.call(attrs, 'tcValidateAllowExpressions');
			var isPositiveOnly = false;
			var currencyConfig = GlobalService.configuration.currency;
			if (angular.isUndefined(currencyConfig)) {
				currencyConfig = {
					groupingSymbol: ',',
					decimalSymbol: '.',
					decimalPlaces: 2
				};
			}
			var groupingSymbolRegExp = new RegExp('\\' + currencyConfig.groupingSymbol, 'g');
			dataType = dataType.replace('Library.', '');
			dataType = dataType.replace('%', '');

			if (dataType.indexOf('+') != -1) {
				isPositiveOnly = true;
				dataType = dataType.replace('+', '');
			}

			// Convert input value to formatted number
			var convertFloat = function(value, isCurrency) {
				var floatValue;
				if (value == '') return '';
				if (Number.isNaN(value)) return;

				// Convert to canonical float
				if (isCurrency) {
					var currencyValue = value;
					value = value.replace(groupingSymbolRegExp, '');
					value = value.replace(currencyConfig.decimalSymbol, '.');
				} else {
					value = value.replace(',', '.');
				}
				floatValue = parseFloat(value);
				if (isNaN(floatValue)) return;

				// Check for constraints
				if ((floatValue < 0) && isPositiveOnly) {
					return;
				}
				
				// Ideally, we should allow up to MAX_SAFE_VALUE for real numbers
				if ((floatValue > Number.MAX_SAFE_INTEGER) || (floatValue < -Number.MAX_SAFE_INTEGER)) {
					return;
				}

				// This was modified from similar checks in TCUI, to ensure entered values are of the right format
				if (isCurrency) {
					currencyValue = currencyValue.replace(/ /g, ''); // strip whitespace
					var integerPart = currencyValue;
					
					//if decimal symbol exists, collect the integer part of the currencyValue for the next check
					if ((currencyValue.indexOf(currencyConfig.decimalSymbol)) !== -1) {
						var currency = currencyValue.split(currencyConfig.decimalSymbol);
						if (currency.length > 2) {
							return;
						} else if (currency.length === 2) {
							if (currency[1] === '') return; //If decimal part is blank, number is invalid
							//If decimal part contains a grouping symbol, number is invalid
							if (currency[1].indexOf(currencyConfig.groupingSymbol) !== -1) return;
							integerPart = currency[0];
						} else {
							if (currency[0]) integerPart = currency[0];
						}
					}
					
					// if grouping symbols exist, check they are formatted correctly
					if ((integerPart.indexOf(currencyConfig.groupingSymbol)) !== -1) {
						var groupings = integerPart.split(currencyConfig.groupingSymbol);
						if (groupings[0] === '') return; //If first element is blank then number is invalid
						// since first element can be shorter than 3, check that all other elements are 3 digits
						for (var j = 1; j < groupings.length; j++) {
							if (groupings[j].length !== 3) return;
						}
					}
				}

				// Round up to decimalPlaces if it's a currency
				if (isCurrency) {
					value = floatValue.toFixed(currencyConfig.decimalPlaces);
				} else {
					value = floatValue.toString();
				}
				
				// Add grouping symbol if it's a currency
				if (isCurrency && (currencyConfig.groupingSymbol != '')) {
					value = value.replace(/(\d)(?=(\d{3})+\.)/g, '$1 ');
				}

				// Replace floating point if needed
				if (currencyConfig.decimalSymbol === ',') {
					value = value.replace('.', ',');
				}

				// Replace ' ' with real grouping symbol
				if (currencyConfig.groupingSymbol !== ' ') {
					value = value.replace(/ /g, currencyConfig.groupingSymbol);
				}

				return value;
			};
			
			// Sets the field as invalid, focuses and selects the value
			var setInvalidAndFocus = function() {
				ngModelCtrl.$setValidity('number', false);
				element[0].focus();
				element[0].select();
			};

			ngModelCtrl.$parsers.push(function(value) {
				// Reset flag that overrides warning/information message
				if ((ngModelCtrl.$error.serverWarning) || (ngModelCtrl.$error.serverInformation)) {
					scope.viewModel.processEventOptions.overrideWarning = false;
				}
				// Reset any error from Cache method on changing the value
				ngModelCtrl.$setValidity('serverError', true);
				ngModelCtrl.$setValidity('serverWarning', true);
				ngModelCtrl.$setValidity('serverInformation', true);
				ngModelCtrl.$setValidity('invalid', true);
				
				if (element[0].tagName === 'TEXTAREA') {
					ngModelCtrl.$setValidity('maxlinelength', true);
				}
				
				return value;
			});
			
			if (dataType == 'Integer') {
				// Convert JSON string value to numeric to pass angular validation
				ngModelCtrl.$formatters.push(function formatInteger(value) {
					if (value === '') return;
					
					var intValue = parseInt(value, 10);
					
					if ((intValue > Number.MAX_SAFE_INTEGER) || (intValue < -Number.MAX_SAFE_INTEGER)) {
						// Display blank rather than an invalid value
						return;
					}
					return intValue;
				});
				
				ngModelCtrl.$parsers.push(function parseInteger(value) {
					ngModelCtrl.$setValidity('number', true);
					// Set to blank string if the browser handled the invalid value
					if (value === null) return '';
					
					if ((value > Number.MAX_SAFE_INTEGER) || (value < -Number.MAX_SAFE_INTEGER)) {
						setInvalidAndFocus();
						return;
					}
					
					// Don't allow floats/decimals in numeric fields
					if ((value) && (Math.floor(value) !== value)) {
						setInvalidAndFocus();
						return;
					}

					if ((value < 0) && isPositiveOnly) {
						setInvalidAndFocus();
						return;
					}
					
					// Convert number to a string for compatibility with component script
					return '' + value;
				});
			} else if (['Float','Numeric','Decimal','Currency','Double'].indexOf(dataType) !== -1) {
				ngModelCtrl.$parsers.push(function parseReal(value) {
					var floatValue;
					var isCurrency = dataType == 'Currency';
					ngModelCtrl.$setValidity('number', true);
					if (angular.isUndefined(value) || value === '') return value;
					
					floatValue = convertFloat(value, isCurrency);
					if (!angular.isString(floatValue)) {
						setInvalidAndFocus();
						return value;
					}
					if (floatValue === 'Infinity') {
						setInvalidAndFocus();
						return;
					}
					
					element.val(floatValue);

					return floatValue;
				});
				
				// Specific logic for iOS software keyboard support
				// See also system.UI.Material:ItemTextbox
				var userAgent = $window.navigator.userAgent || $window.navigator.vendor || $window.opera;
				if (userAgent.match(/ipad/i)) {
					// For iPad, 'tel' type invokes standard numeric keypad
					element.attr('type', 'tel');
				} else if (userAgent.match(/iphone/i)) {
					// For iPhone, only 'number' type invokes the numeric keypad with decimal/comma included
					// Switch field between types using this hack
					element.on('touchstart', function() {
						var value = element.val();
						// Clear out any comma grouping symbol, so our formatted currency fields
						// can also use the numeric keypad
						if (currencyConfig.groupingSymbol === ',') {
							value = value.replace(groupingSymbolRegExp, '');
							element.val(value);
						}
						// For decimal-comma locales, don't change the type (use alpha keypad if there is a value with a comma)
						// The field is cleared on changing types if there is a comma, regardless of iOS locale
						if (value.indexOf(',') === -1) {
							element.attr('type', 'number');
						}
					});

					element.on('keydown blur', function() {
						element.attr('type', 'text');
					});
				}
			} else {
				// String - strip carets unless expressions are allowed
				if (!allowExpressions) {
					ngModelCtrl.$parsers.push(function parseString(value) {
						var pattern = /\^/gi;
						value = value.replace(pattern, '');
						element.val(value);
						return value;
					});
				}
			}
		}
	};
});
